var $9516ade4a4f015ec$exports = {};
$9516ade4a4f015ec$exports = {
    "Empty": `Pr\xe1zdn\xe9`
};


export {$9516ade4a4f015ec$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
